// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const GcpGkeNodePoolTaintEffect = {
  GkeNodePoolTaintEffectNoSchedule: 'NO_SCHEDULE',
} as const;
export type GcpGkeNodePoolTaintEffect =
  (typeof GcpGkeNodePoolTaintEffect)[keyof typeof GcpGkeNodePoolTaintEffect];

export function instanceOfGcpGkeNodePoolTaintEffect(value: any): boolean {
  for (const key in GcpGkeNodePoolTaintEffect) {
    if (Object.prototype.hasOwnProperty.call(GcpGkeNodePoolTaintEffect, key)) {
      if (
        GcpGkeNodePoolTaintEffect[
          key as keyof typeof GcpGkeNodePoolTaintEffect
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function GcpGkeNodePoolTaintEffectFromJSON(
  json: any,
): GcpGkeNodePoolTaintEffect {
  return GcpGkeNodePoolTaintEffectFromJSONTyped(json, false);
}

export function GcpGkeNodePoolTaintEffectFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GcpGkeNodePoolTaintEffect {
  return json as GcpGkeNodePoolTaintEffect;
}

export function GcpGkeNodePoolTaintEffectToJSON(
  value?: GcpGkeNodePoolTaintEffect | null,
): any {
  return value as any;
}

export function GcpGkeNodePoolTaintEffectToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): GcpGkeNodePoolTaintEffect {
  return value as GcpGkeNodePoolTaintEffect;
}
